import { Injectable, Injector } from '@angular/core';
import { AdyenTenderOptionsEnum } from '../enums';
import { StorageKeys } from '@shared/constants';
import { LocalStorage } from '@core/services/utils/localstorage.utils';
import { IActiveTerminal } from '@shared/interfaces';
import { Invoice } from '@shared/classes/invoice.class';
import { PosSettingsService } from '@core/services/system/pos-settings.service';
import { LogService } from '@core/services/system/logger';
import { ILogger } from '@paymash/logging';
import { PaymentResult } from '@shared/classes/payment-result.class';
import { PAYMENT_PROVIDERS } from '@shared/constants/payment-providers.const';
import { TippingService } from '@core/services/system/tipping/tipping.service';
import { InvoicePayment } from '@shared/classes/invoice-payment.class';
import { InvoiceEntry } from '@shared/classes/invoice-entry.class';
import {
  getGratuityAmountFromMerchantReceipt
} from '@core/services/system/adyen/services/helpers/parse-gravity.helper';

@Injectable()
export class AdyenTippingService {
  private readonly logger: ILogger = this.logService.createLogger('AdyenTippingService');
  constructor(
    private logService: LogService,
    private localStorage: LocalStorage,
    private injector: Injector) { }

  public get add(): AdyenTenderOptionsEnum {
    return AdyenTenderOptionsEnum.Tipping;
  }

  public get isTippingAllowed(): boolean {
    const terminal: IActiveTerminal = this.localStorage.getObject(StorageKeys.activeTerminal);
    return terminal?.tipAllowed;
  }

  public get isLegacyPosTippingAllowed(): boolean {
    return this.getLegacyTippingSettings();
  }

  public isNeedAdyenNativeTippingAddFlow(provider: string, result: PaymentResult): boolean {
    return provider === PAYMENT_PROVIDERS.PAYMASH_PAY
    && this.isTippingAllowed
    && this.isLegacyPosTippingAllowed
    && !!result?.terminalTransaction?.nativeTippingAmount
  }

  public setLegacyTippingToInvoice(invoice: Invoice, amount: number, guest: number): Invoice {
    const tippingService: TippingService = this.injector.get(TippingService);
    this.logger.info('Legacy tipping for Adyen to invoice...', { invoice, amount });

    tippingService.setTipEvent({ amount, source: 'paymashPay' });
    invoice = tippingService.addTippingInvoiceEntryToInvoice(invoice, guest, true, 'ZERO_DOT_ZERO_ONE');
    return invoice;
  }

  public isTipsAlreadyPaidByPaymashPay(invoice: Invoice, amountTips: number): boolean {
    const { invoicePayments, invoiceEntries } = invoice;
    const isValueAlreadyPaidTipByPaymashPay: boolean = invoicePayments?.some((item: InvoicePayment): boolean => getGratuityAmountFromMerchantReceipt(item.merchantReceipt)?.amount === amountTips) || false;
    const isEntriesHasAdyenNativeTipping: boolean = invoiceEntries?.some((entry: InvoiceEntry): boolean => entry.type === 'TIPS' && entry.price === amountTips) || false;
    return isValueAlreadyPaidTipByPaymashPay && isEntriesHasAdyenNativeTipping
  }

  private getLegacyTippingSettings(): boolean {
    const posSettings: PosSettingsService = this.injector.get(PosSettingsService);
    return posSettings.getTippingStatus();
  }

}
